module.exports = __webpack_public_path__ + "img/marca-escola-da-serra.b8be9902.png";